import { useEffect, useCallback } from "react";
import { useLocation } from "react-router";
import { apiUsers as api, APIError } from "../services/apiUsers";
import { logoutUser } from "../redux/authSlice";
import { useDispatch } from "react-redux";

function RouteChangeHandler() {
  const location = useLocation();
  const dispatch = useDispatch();
  const storedAuth = localStorage.getItem("auth");
  const parsedAuth = JSON.parse(storedAuth);

  // Función que se ejecutará en cada cambio de ruta o recarga
  const handleRouteChange = useCallback((path) => {
    // Aquí puedes agregar cualquier lógica que quieras ejecutar
  }, []);

  const loadArticles = async () => {
    try {
      await api.checkUser();
    } catch (error) {
      if (error instanceof APIError) {
        if (
          error.status === 403 &&
          parsedAuth?.usuario &&
          parsedAuth?.token &&
          !window.location.pathname.includes("/Novedades")
        ) {
          dispatch(logoutUser());
        } /*else {
            console.error(error)
          }*/
      } /*else {
          console.error(error)
        }*/
    }
  };

  useEffect(() => {
    loadArticles();
    handleRouteChange(location.pathname);

    // Detectar recargas de página
    const handleBeforeUnload = () => {
      // Nota: Este log no será visible en la consola después de la recarga,
      // pero puedes realizar otras acciones aquí si es necesario
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [handleRouteChange, location.pathname]); // Array de dependencias vacío, se ejecuta solo al montar

  // Este efecto se ejecuta en cada cambio de ruta
  useEffect(() => {
    handleRouteChange(location.pathname);
  }, [location.pathname, handleRouteChange]);

  // Este componente no renderiza nada visible
  return null;
}

export default RouteChangeHandler;
